export default __webpack_public_path__ + "static/media/checkmark.25f6e542.svg";